import { render, staticRenderFns } from "./MessageAudits.vue?vue&type=template&id=0191510b&scoped=true&"
import script from "./MessageAudits.vue?vue&type=script&lang=js&"
export * from "./MessageAudits.vue?vue&type=script&lang=js&"
import style0 from "./MessageAudits.vue?vue&type=style&index=0&id=0191510b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0191510b",
  null
  
)

export default component.exports